import { renderBackgroundColorByTheme, renderColorPrimary } from "@/common/function/FunctionTheme";
import styled from "styled-components";

export const MenuBarWrapper = styled.div<{$theme?: string}>`
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  background-color: ${props => renderBackgroundColorByTheme(props.$theme)};

  @media (max-width: 250px) {
    overflow: auto;
  }

  @media (max-width: 250px) {
    white-space: nowrap;
  }
`;

export const ItemBarTooltipWrapper = styled.div<{$theme?: string}>`
  text-align: center;
  padding: 4.5px;
  line-height: 10px;
  position: relative;
  height: 40px;

  &:hover {
    cursor: pointer;
  }
`;

export const ItemBarTooltipTitleWrapper = styled.div<{$theme?: string}>`
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #616161;
`;

export const ImgIconTooltipWrapper = styled.div<{ $isActive?: boolean, $theme?: string }>`
  margin-top: 2.5px;
  color: ${(props) => (props.$isActive ? "#106ebe !important" : "#616161")};
`;

export const ActiveBarWrapper = styled.div<{ $isActive?: boolean, $theme?: string }>`
  border-top: 2px solid ${props => renderColorPrimary(props.$theme)};
  width: 68.4px;
  border-radius: 0px 0px 29px 28px;
  position: absolute;
  top: 0px;
  left: -16px;
  display: ${(props) => (props.$isActive ? null : "none")};
`;

export const ItemBarWrapper = styled.div<{$theme?: string}>`
  text-align: center;
  padding: 4.5px;
  line-height: 10px;

  &:hover {
    cursor: pointer;
    filter: invert(32%) sepia(85%) saturate(6184%) hue-rotate(195deg)
      brightness(93%) contrast(67%);
  }
`;

export const ItemBarTitleWrapper = styled.div<{ $isActive?: boolean, $theme?: string }>`
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => (props.$isActive ? "#106ebe !important" : "#616161")};
`;

export const BoxItemBarWrapper = styled.div`
  height: 40px;
`;

export const ActiveLineWrapper = styled.div<{ $isActive?: boolean, $theme?: string }>`
  color: ${(props) => (props.$isActive ? "#106ebe !important" : "#616161")};
`;
